import {
  Brand,
  MobileVariant,
  Stepper
} from '@storebrand-digital/insurance-stepper';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useCorporateContext } from '../../../../CorporateContext';
import CheckMarkIcon from '../../../../assets/check-circle-yellow.svg';
import { FormDataContext } from '../../../Form';
import { stepsCorporate, stepsPrivate } from './claimStepsDefinition';
import { getStepperIndex, markCompletedSteps } from './helpers';
import { ClaimStepperWrapper } from './styled';

interface ClaimStepperProps {
  index: number;
  childrenCount: number;
  children: React.ReactNode;
}

export const ClaimStepper = ({
  index,
  childrenCount,
  children
}: ClaimStepperProps) => {
  const { isCorporate } = useCorporateContext();
  const formData = useContext(FormDataContext);
  const { pathname } = useLocation();
  const stepperIndex = getStepperIndex(
    index,
    pathname,
    childrenCount,
    isCorporate,
    formData
  );

  const steps = isCorporate ? stepsCorporate : stepsPrivate;
  const currentStep = steps[stepperIndex];

  markCompletedSteps(stepperIndex, steps);

  return (
    <Stepper
      branding={Brand.STB}
      stepCompleteIcon={<CheckMarkIcon />}
      disableUpcomingSteps
      disableNavigation
      desktopAlign="left"
      desktopContentWidth={100}
      currentStep={currentStep}
      handleNavigate={currStep => {
        currStep.complete = true;
      }}
      steps={steps}
      mobileVariant={MobileVariant.VERTICAL_LINE_COMPACT}
    >
      <ClaimStepperWrapper>{children}</ClaimStepperWrapper>
    </Stepper>
  );
};
